class Authheader {
    constructor() {
        this.TenantHeader = "X-Tenant-ID";
    }
}
export const AuthHeaders = new Authheader();
